import { render, staticRenderFns } from "./RatingDialog.vue?vue&type=template&id=18d2de05&scoped=true"
import script from "./RatingDialog.vue?vue&type=script&lang=js"
export * from "./RatingDialog.vue?vue&type=script&lang=js"
import style0 from "./RatingDialog.vue?vue&type=style&index=0&id=18d2de05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2de05",
  null
  
)

export default component.exports